export const followPropertyModalPageSource = 'follow_property_modal';
